import React from 'react';
import PropTypes from 'prop-types';

import MarketOverviewPriceChartContainer from './MarketOverviewPriceChartContainer';
import InstrumentTableContainer from '../InstrumentTable/InstrumentTableContainer';
import InstrumentSelectorContainer from 'apex-web/lib/components/InstrumentSelector/InstrumentSelectorContainer';
import { getBEMClasses } from '../../helpers/cssClassesHelper';
import './MarketOverviewComponent.css';

const marketOverviewClasses = getBEMClasses('market-overview');

const MarketOverviewComponent = ({ omitPriceTable, hideInstrumentSelector }) => {
  return (
    <div className={marketOverviewClasses('body')}>
      <div
        className={marketOverviewClasses('chart-component-container', {
          'no-top-selector': hideInstrumentSelector
        })}>
        {!hideInstrumentSelector && (
          <div className={marketOverviewClasses('instrument-selector')}>
            <InstrumentSelectorContainer
              customClass="market-overview-popup"
              showFullNameInstrument
              showTriangles
            />
          </div>
        )}
        <MarketOverviewPriceChartContainer
          customClass={marketOverviewClasses('retail-price-chart-container')}
        />
      </div>
      {!omitPriceTable && (
        <div className={marketOverviewClasses('market-overview-container')}>
          <InstrumentTableContainer customClass="market-overview-instrument" />
        </div>
      )}
    </div>
  );
};

MarketOverviewComponent.propTypes = {
  omitPriceTable: PropTypes.bool,
  hideInstrumentSelector: PropTypes.bool
};

MarketOverviewComponent.defaultProps = {
  omitPriceTable: false,
  hideInstrumentSelector: false
};

export default MarketOverviewComponent;
